import { BrowserRouter } from "react-router-dom";
import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import store from "./redux/app/Store";
import { CookiesProvider } from "react-cookie";

function App() {
  return (
    <>
      {/* main route components */}
      <Provider store={store}>
        <CookiesProvider defaultSetOptions={{ path: "/" }}>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
          <ToastContainer />
        </CookiesProvider>
      </Provider>
    </>
  );
}

export default App;
